import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LinkConfig } from '../../core/helpers/utils';

@Component({
  selector: 'rosie-alert',
  template: `
    <div class="alert" [ngClass]="type + ' ' + customClass" [dataHook]="'alert-' + type">
      <div class="d-flex align-items-center justify-content-center icon-wrapper">
          <div class="{{iconClass}} alert-icon" [style.background-image]="customIcon ? getCustomIconUrl() : null"></div>
      </div>
      <div class="d-flex align-items-center">
        <div *ngIf="message" class="alert-message">{{ message | translate }}</div>
        <span *ngIf="link?.url">&nbsp;<a class="link" (click)="navigateTo(link.url)">{{ link.title | translate }}</a></span>
      </div>
      <span *ngIf="innerHtml" [innerHTML]="innerHtml"></span>
    </div>
  `,
  styleUrls: ['./alert.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class AlertComponent implements OnInit {
  @Input() message = '';
  @Input() innerHtml: string;
  @Input() type: AlertType = AlertType.Error;
  @Input() customClass = '';
  @Input() customIcon?: string = '';
  @Input() link?: LinkConfig;

  constructor(private router: Router) {
  }

  get iconClass(): string {
    return `${this.type}-alert-icon`;
  }

  ngOnInit(): void {
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  getCustomIconUrl(): string {
    return `url('assets/images/${this.customIcon}')`;
  }
}

export enum AlertType {
  Error = 'error',
  ErrorInfo = 'error-info',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Guide = 'guide',
  Caution = 'caution'
}

export interface AlertConfig {
  message: string;
  type: AlertType;
  customClass?: string;
  customIcon?: string;
  link?: LinkConfig;
  innerHtml?: string;
}